export default {
    title: 'Acquisti',
    icon: 'mdi-cash-multiple',
    groups: ['Amministrazione'],
    submenu: [
        {
            title: 'Riepilogo',
            route: {name: 'acquisti-home'},
        },
        {
            title: 'Lamiera',
            route: {name: 'acquisti-lamiera'},
        },
        {
            title: 'Tubi',
            route: {name: 'acquisti-tubi'},
        },
        {
            title: 'Conto Lavoro',
            route: {name: 'acquisti-contolavoro'},
        },
        {
            title: 'Ricevimenti',
            route: {name: 'acquisti-ricevimenti'},
        },
    ]
}
